<template>
  <div id="list-review" class="data-list-container vs-con-loading__container" v-if="config.gocheckin_feature == 1">
    <!-- <vs-breadcrumb :items="items" class="mb-6"></vs-breadcrumb> -->
    <div class="vx-breadcrumb mb-6">
        <ul class="flex flex-wrap items-center">
            <li class="inline-flex items-end">
                <router-link to="/after-login">
                    <feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" />
                </router-link>
                <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
            </li>
            <li class="inline-flex items-end">
              <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Review List</span>
            </li>
        </ul>
    </div>
    <vs-row class="mb-6">
      <vs-col class="w-1/3 md:w-2/3">
        <h4 class="text-2xl font-bold">Review</h4>
      </vs-col>
      <vs-col class="w-2/3 md:w-1/3">
        <vs-row>
          <vs-col class="w-1/2 pr-6">
            <!-- <v-select
              v-model="sort_by"
              :options="['a', 'b', 'c']"
              label="Sort by"
              style="background: #fff"
            ></v-select> -->
              <vs-dropdown vs-trigger-click class="cursor-pointer item-per-page-dropdown ml-0 w-full">
              <div
                class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium sort-dropdown"
              >
                <span class="mr-2 text-sm">{{sort_by.title}}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu style="width: 170px;">
                <vs-dropdown-item v-for="(item, i) in sortOptions" :key="i" v-model="sort_by" @click="sortList(item)">
                  <span class="w-full flex justify-between" :class="{'text-primary': sort_by.id == item.id}">
                    {{item.title}}
                    <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="sort_by.id == item.id"/>
                  </span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </vs-col>
          <vs-col class="w-1/2">
            <div class="search-page__search-bar flex items-center">
              <vs-input
                icon-no-border
                placeholder="Search"
                v-model="searchQuery"
                class="w-full rounded-item"
                icon="icon-search"
                icon-pack="feather"
                @input="searchReview($event)"
              />
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-tabs :color="colorx" :value="active_tab" :key="content_key">
        <vs-tab @click="colorx = 'primary'" label="All">
          <div class="con-tab-ejemplo" v-if="isLoaded">
            <all-review-content :infoObj="infoObj" :search="search" :sort_by="sort_by" :currentPage="currentPage" :itemsPerPage="itemsPerPage" @ChangeReview="changeReview" @ChangePage="changePage" @EmotionalFilter="emotionalFilterFromAll" :content_key="content_key" :key="content_key" @GetDataComplete="getDataComplete"></all-review-content>
          </div>
        </vs-tab>

        <vs-tab @click="colorx = 'primary'" id="gocheckin-tab" label="Go Check-in">
          <div class="con-tab-ejemplo">
              <go-checkin-review-content :infoObj="infoObj" :search="search" :sort_by="sort_by" :currentPage="currentPage" :itemsPerPage="itemsPerPage" @ChangeReview="changeReview" @ChangePage="changePage" @EmotionalFilter="emotionalFilter" :filterRating="filterRating" :content_key="content_key" :key="content_key" @GetDataComplete="getDataComplete"></go-checkin-review-content>
          </div>
        </vs-tab>

        <!-- <vs-tab @click="colorx = 'primary'" id="yelp-tab" label="Yelp">
          <div class="con-tab-ejemplo">
              <yelp-review-content :search="search" :sort_by="sort_by" :currentPage="currentPage" :itemsPerPage="itemsPerPage" @ChangeReview="changeReview" @ChangePage="changePage" :content_key="content_key" :key="content_key" @GetDataComplete="getDataComplete"></yelp-review-content>
          </div>
        </vs-tab> -->

        <vs-tab @click="colorx = 'primary'" id="google-tab" label="Google">
          <div class="con-tab-ejemplo">
              <google-review-content :infoObj="infoObj" :search="search" :sort_by="sort_by" :currentPage="currentPage" :itemsPerPage="itemsPerPage" @ChangeReview="changeReview" @ChangePage="changePage" :content_key="content_key" :key="content_key" @GetDataComplete="getDataComplete"></google-review-content>
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-row>
  </div>
  <div v-else-if="config.gocheckin_feature == 0">
    <vx-card>
      <h2>
        This is for Go Check In full version, please contact us for more info at
        <b>832-968-6668</b>
      </h2>
    </vx-card>
  </div>
  <custom-spinner v-else></custom-spinner>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: "vs-list-review",
  components: {
    "v-select": vSelect
  },
  props: {
    typeFromDashboard: {
      type: String,
      default: 'all'
    }
  },
  data() {
    return {
      search: '',
      itemsPerPage: 5,
      currentPage: 1,
      content_key: 0,
      colorx: "primary",
      searchQuery: "",
      review_type: 'all',
      sort_by: {id: 0, title: 'Sort By', value: ''},
      sortOptions: [
        {id: 1, title: 'Latest', value: '-time_create'},
        {id: 2, title: 'Oldest', value: 'time_create'},
        {id: 3, title: 'Highest Rated', value: '-rating'},
        {id: 4, title: 'Lowest Rated', value: 'rating'}
      ],
      items: [
        {
          title: 'Home',
          url: '/',
          icon: "HomeIcon",
        },
        {
          title: 'Review List',
          active: true,
        }
      ],
      isLoaded: false,
      filterRating: 0,
      active_tab: 0,
      loaded_data_num: 0,
      infoObj: {
        page: 1,
        "per-page": this.itemsPerPage ? this.itemsPerPage : 5,
        user_name: this.search ? this.search : ''
      }
    }
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 2) {
          this.closeLoading();
        } else {
          this.action_type = "Get data";
          this.openLoadingInDiv();
        }
      }
    },
    config: {
      immediate: true,
      deep: true,
      handler() {
        if(this.config && this.config.gocheckin_feature == 0) {
          this.loaded_data_num = 2;
        }
      }
    }
  },
  methods: {
     openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
    },
    changeReview(type) {
      this.review_type = type;
      this.currentPage = 1;
      if(type != 'gocheckin') {
        this.filterRating = 0;
      }
      this.getActiveTab(type);
      if(this.isLoaded) {
        this.loaded_data_num = 1;
      } else {
        this.loaded_data_num = 0;
      }
    },
    getActiveTab(type) {
      if(type == 'all') {
        this.active_tab = 0;
      }
      if(type == 'gocheckin') {
        this.active_tab = 1;
      }
      if(type == 'yelp') {
        this.active_tab = 2;
      }
      if(type == 'google') {
        this.active_tab = 3;
      }
    },
    sortList(item) {
      this.sort_by = item;
      this.content_key++;
    },
    changePage(page) {
      this.currentPage = page;
      this.content_key++;
    },
    searchReview(target){
      this.search = target;
      this.content_key++;
    },
    emotionalFilter(rating) {
      this.search = '';
      this.searchQuery = '';
      this.filterRating = rating;
      this.content_key++;
    },
    emotionalFilterFromAll(rating) {
      this.search = '';
      this.searchQuery = '';
      this.filterRating = rating;
      this.active_tab = 1;
      this.content_key++;
    },
    getDataComplete() {
      this.loaded_data_num++;
    }
  },
  computed: {
    config() {
      return this.$store.getters["auth/config"];
    }
  },
  created() {
    this.$store.dispatch('reviewList/GET_REVIEW_REPORT').then(()=> {
      this.isLoaded = true;
      this.loaded_data_num++;
    });
    if(this.typeFromDashboard && this.typeFromDashboard != 'all') {
      this.getActiveTab(this.typeFromDashboard);
    }
  }
};
</script>
